import { computed, unref } from '@vue/composition-api';
import { useStore } from '@vueblocks/vue-use-vuex';
import useRouter from './useRouter';
import useRoute from './useRoute';

import AlarmMsg from '@/utils/alarmMsg';

export default function useUserInfo() {
	const store = useStore();
	const router = useRouter();
	const route = useRoute();
	const userInfo = computed(() => store.getters.userInfo);
	const isLoggedIn = computed(() => store.getters.isLoggedIn);
	const isSpecialGrade = computed(() => store.getters.isSpecialGrade);

	const withLoggedIn =
		(callback, { message = '로그인 시 사용 가능한 기능입니다.</br>로그인을 해주세요.' } = {}) =>
		async (...args) => {
			{
				const { query, path, name, params } = unref(route);
				if (!unref(isLoggedIn)) {
					await AlarmMsg.showMsg(message);
					router.replace({
						name: 'login',
						params: { query, path, name, params },
					});
					return;
				}
				await callback?.(...args);
			}
		};

	return {
		userInfo,
		isMasterMember: computed(() => store.getters.isMasterMember),
		isSubMember: computed(() => store.getters.isSubMember),
		isLoggedIn,
		isSpecialGrade,
		withLoggedIn,
		logout: () => store.dispatch('Logout'),
		update: () => store.dispatch('updateUserInfo'),
	};
}
